import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import classnames from 'classnames';

import AddIcon from '../../img/icons/Plus';
import EditIcon from '../../img/icons/Upravit';
import MoveIcon from '../../img/icons/BBicons_Presunout_portfolio';
import CopyIcon from '../../img/icons/BBicons_Kopirovat_portfolio';
import ToolsIcon from '../../img/icons/BBicons_Spravovat_portfolio';
import SaveIcon from '../../img/icons/BBicons_Ulozit';
import DeleteIcon from '../../img/icons/BBiconsOdstranit';

import './linkButton.scss';

export const BUTTON_TYPE = {
    none: 0,
    addUser: 1,
    edit: 2,
    remove: 3,
    tools: 4,
    move: 5,
    copy: 6,
    save: 7
}

class LinkButton extends React.Component {
    static defaultProps = {
        type: BUTTON_TYPE.none,
        onClick: undefined,
        size: 1.25,
        customStyle: undefined,
        disabled: false,
        showLabelOnMobile: false
    };

    static propTypes = {
        type: PropTypes.number,
        onClick: PropTypes.func,
        size: PropTypes.number,
        customStyle: PropTypes.object
    };

    render() {
        let Icon, label;
        switch (this.props.type) {
            case BUTTON_TYPE.addUser:
                Icon = AddIcon;
                label = this.props.translate("Common.Button.AddUser");
                break;
            case BUTTON_TYPE.edit:
                Icon = EditIcon;
                label = this.props.translate("Common.Button.Edit");
                break;
            case BUTTON_TYPE.remove:
                Icon = DeleteIcon;
                label = this.props.translate("Common.Button.Remove");
                break;
            case BUTTON_TYPE.tools:
                Icon = ToolsIcon;
                label = this.props.translate("Common.Button.Tools");
                break;
            case BUTTON_TYPE.move:
                Icon = MoveIcon;
                label = this.props.translate("Common.Move");
                break;
            case BUTTON_TYPE.copy:
                Icon = CopyIcon;
                label = this.props.translate("Common.Copy");
                break;
            case BUTTON_TYPE.save:
                Icon = SaveIcon;
                label = this.props.translate("Common.Button.Save");
                break;
            default:
                return null;
        }

        return (
            <div className={classnames("bb-link-button", "color", { "disabled": this.props.disabled })}>
                <div className="bb-link-button-inner">
                    <a className="link-internal" onClick={this.props.onClick}>
                        <div style={{ display: "flex" }}>
                            <span><Icon className="bb-link-button-icon" /></span>
                            <span className={classnames({ "hide-on-mobile": !this.props.showLabelOnMobile })}>{label}</span>
                        </div>
                    </a>
                </div>
            </div>
        )
    }
}

export default withLocalize(LinkButton);